import { SubscriptionTitlesMap, type SubscriptionTypes } from "../types/checkout.types";

export const getSubscriptionTitle = (
  subscriptionOption: SubscriptionTypes
): string => {
  return SubscriptionTitlesMap.get(subscriptionOption) || "";
};
